import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["placeholder", "value", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar fa-lg m-1" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-group form-group-block form-input-group date", [ _ctx.disabled ? 'disabled' : '' , _ctx.borderClass ]]),
      ref: "dt"
    }, [
      _createElementVNode("label", null, [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          class: _normalizeClass(["form-control", _ctx.inputClass]),
          type: "text",
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateInput && _ctx.updateInput(...args))),
          ref: "dtInput",
          disabled: _ctx.disabled
        }, null, 42, _hoisted_2),
        _hoisted_3
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "description")
  ], 64))
}